import { Link, router, usePage } from "@inertiajs/react";
import VerificationAlert from "@/Shared/MiniComponent/VerificationAlert";
import { useEffect, useRef, useState } from "react";
import Axios from "axios";
import NotifBubble from "@/Shared/NotifBubble";
import ModalLoginAndRegister from "@/Shared/ModalLoginAndRegister";


function Navbar({ user }) {
    const menuAgency = useRef(null);
    const menuContentAgency = useRef(null);
    const menuTitleAgency = useRef(null);
    const btnHamburger = useRef(null);
    const [ticketNotifCount, setTicketNotifCount] = useState(0);


    // Get ticket notif
    useEffect(()=>{
        user && Axios.get("/my/tiket/notif").then((res) =>
            setTicketNotifCount(res.data.bookingAmount)
        );
    },[user])

    const [activeMenu, setActiveMenu] = useState('');
    const [toggleMenu, setToggleMenu] = useState('');

    const showMenu = (menu) => {
        setActiveMenu(menu);
        setToggleMenu(''); 
    };

    const showToggle = (menu) => {
        if (toggleMenu !== menu) {
            setActiveMenu(menu);
            setToggleMenu(menu);
        } else {
            setToggleMenu('');
        }
    };
    
    const url = window.location.pathname;

    useEffect(() => {
        if (url === '/') {
            showMenu('home');
        } else if (url.includes('/event')) {
            showMenu('event');
        } else if (url.includes('/cari-manpower')) {
            showMenu('manpower');
        } else if (url.includes('/mission')) {
            showMenu('mission');
        }
    }, [url]);
    


    const menuClass = "ms-1 ms-lg-4";
    const imageUrl = user && user.avatar_path;
    // const userMenu = user && userMenu
    const [openModal, setOpenModal] = useState(0)
    const [redirectUrl, setRedirectUrl] = useState(null)
    const loginButton = !user && (
        <li className={`list-unstyled pt-2 pt-lg-0 my-auto ${menuClass}`}>
            <a className="btn-login order-0" onClick={() => setOpenModal(1)}>
                Masuk
            </a>
            <ModalLoginAndRegister 
                openModal={openModal} 
                openLogin={() => { setOpenModal(1)}} 
                openRegister={(e) => {e.preventDefault(); setOpenModal(2)}} 
                openFormRegister={() => {setOpenModal(3)}} 
                onClose={(e) => {setOpenModal(0); setRedirectUrl(null)}}
                redirectUrl={redirectUrl} 
            />
        </li>
    );

    function handleLogout(e) {
        e.preventDefault();
        setOpenModal(0)
        router.post("/auth/logout");
    }


    function EventList() {

        const createMobileEventLink = user? (
            <Link
                href="/event-creator" 
                style={{fontSize: '10px'}}
                className="nav-item text-decoration-none text-white mm-p-xs"
            >Buat Event
            </Link>
        ):(
            <Link onClick={(e)=>{
                    e.preventDefault();
                    setOpenModal(1)
                    setRedirectUrl("/event-creator")
                }} 
                style={{fontSize: '10px'}}
                className="nav-item text-decoration-none text-white mm-p-xs">
                Buat Event
            </Link>
        )
        return (
            <>
                <div id="event-menu-list" className="mobile-menu-list" >
                    <div className="nav-list shadow-lg me-2 btn btn-sm btn-main-blue rounded-pill">
                        <Link className="nav-item text-decoration-none text-white mm-p-xs" href="/event">Cari Event</Link>
                    </div>
                    <div className="nav-list shadow-lg me-2 btn btn-sm btn-main-blue rounded-pill">
                        {createMobileEventLink }
                    </div>
                </div>
            </>
        );
    }

    function ManPowerList() {
        return (
            <>
                <div id="manpower-menu-list" className="mobile-menu-list">
                    <div className="nav-list shadow-lg me-2 btn btn-sm btn-main-blue rounded-pill" style={{width: '101px'}}>
                        <a 
                            href="https://docs.google.com/forms/d/e/1FAIpQLSekzuhJkweFJZWqk_1J6cvYS1DpPMale3qPvjev93pmUYZyyQ/viewform" 
                            target="__blank"
                            className="nav-item text-decoration-none text-white" 
                            style={{fontSize: '10px'}}>
                                Jadi Manpower
                        </a>
                    </div>
                    <div className="nav-list shadow-lg me-2 btn btn-sm btn-main-blue rounded-pill" style={{width: '101px'}}>
                        <a href="/cari-manpower" className="nav-item text-decoration-none text-white" style={{fontSize: '10px'}}>Cari Manpower</a>
                    </div>
                </div>
            </>
        );
    }


    return (
        <>
        <nav className="navbar navbar-main navbar-expand-lg navbar-light bg-white sticky-top">
            {user &&
                !user.email_verified_at &&
                window.location.href.indexOf("auth/email/verify") == -1 && (
                    <VerificationAlert />
                )}
            <div className="container-fluid">
                <Link className="navbar-brand" href="/">
                    <img src="/images/logo-acaraitu.png" alt="logo" />
                </Link>
                <div className={`d-flex flex-nowrap order-lg-2 ${menuClass}`}>
                    <button
                        className="navbar-toggler order-1 ms-1 ms-md-2 px-2 d-none d-md-block d-lg-none"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        ref={btnHamburger}
                    >
                        <span className="toggler ">
                            <img src="/images/icon/menu_icon.svg" alt="Menu" />
                        </span>
                    </button>
                    <div className="d-block d-md-none">
                        {loginButton}
                    </div>
                    {user?
                        <UserMenu
                            user={user} 
                            imageUrl={imageUrl} 
                            ticketNotifCount={ticketNotifCount} 
                            handleLogout={handleLogout}
                        />
                        :""
                    }
                </div>
                <div
                    className="navbar-main__menu collapse navbar-collapse order-2 order-lg-1 pt-2 pt-lg-0"
                    id="navbarSupportedContent"
                >
                    <ul className="navbar-nav ms-auto">
                        {<DropdownProject />}
                        <li className="nav-item">
                            <Link
                                className="nav-link navbar-link"
                                href="/mission"
                            >
                                Mission
                            </Link>
                        </li>
                        <DropdownEvent 
                            user={user} 
                            setOpenModal={setOpenModal}
                            setRedirectUrl={setRedirectUrl}
                        />
                        {/* <DropdownMedia /> */}
                        {/* <DropdownAgency /> */}
                        {loginButton}
                    </ul>
                </div>
            </div>
        </nav>

        {/* Navbar Mobile */}
        <nav className="navbar-mobile d-md-none navbar navbar-main navbar-expand-lg navbar-light d-block bg-white fixed-bottom rounded-3 mx-auto shadow-lg pt-1">
            <div className="container-fluit">
                <ul className="d-flex justify-content-around align-items-center">
                    <li className="nav-mobile-item" onClick={() => showMenu('home')}>
                        <Link href="/" className={`nav-mobile-list ${activeMenu === 'home' ? 'active' : ''}`}>
                            <img src={`/images/icon/nav-icon/${activeMenu === 'home' ? 'home-active.svg' : 'home-deactive.svg'}`} alt="home" />
                            <span className="d-block" style={{fontSize: '10px'}}>Home</span>
                        </Link>
                    </li>
                    <li className="nav-mobile-item" onClick={() => showToggle('event')}>
                        <div className={`nav-mobile-list ${activeMenu === 'event' ? 'active' : ''}`}>
                            <img src={`/images/icon/nav-icon/${activeMenu === 'event' ? 'event-active.svg' : 'event-deactive.svg'}`} alt="event" />
                            <span className="d-block" style={{fontSize: '10px'}}>Event</span>
                        </div>
                        {toggleMenu === 'event' && <EventList />}
                    </li>
                    <li className="nav-mobile-item" onClick={() => showToggle('manpower')}>
                        <div className={`nav-mobile-list ${activeMenu === 'manpower' ? 'active' : ''}`}>
                            <img src={`/images/icon/nav-icon/${activeMenu === 'manpower' ? 'manpower-active.svg' : 'manpower-deactive.svg'}`} alt="manpower" />
                            <span className="d-block" style={{fontSize: '10px'}}>Manpower</span>
                        </div>
                        {toggleMenu === 'manpower' && <ManPowerList />}
                    </li>
                    <li className="nav-mobile-item" onClick={() => showMenu('mission')}>
                        <Link href="/mission" className={`nav-mobile-list ${activeMenu === 'mission' ? 'active' : ''}`}>
                            <img src={`/images/icon/nav-icon/${activeMenu === 'mission' ? 'mission-active.svg' : 'mission-deactive.svg'}`} alt="mission" />
                            <span className="d-block" style={{fontSize: '10px'}}>Mission</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
        </>
    );
}

function UserMenu({user, imageUrl, ticketNotifCount, handleLogout}) {

    const [dropdownWidth, setDropdownWidth] = useState("200px")

    const resizeDropdownWidth = (mq)=> mq.matches ? setDropdownWidth("200px"):setDropdownWidth("300px")

    const mediaQuery = window.matchMedia("(max-width:375px)")
    
    useEffect(()=>{
        resizeDropdownWidth(mediaQuery)
    },[])

    mediaQuery.addEventListener("change", resizeDropdownWidth)

    return (
        <div className="dropdown order-0">
            <a
                className="d-inline-block text-decoration-none text-reset border rounded-pill px-2 py-1 border-main-red"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <img
                        src={imageUrl}
                        className="hero rounded-circle"
                        alt="Profile"
                        style={{width: "32px",height:"32px"}}
                    />
                    <p 
                        className="mb-0 ms-1 me-1 fw-bold d-none d-sm-block text-main-red" 
                        style={{fontSize:"0.75em"}}
                    >{user.name.split(" ").splice(0,1).join(" ")}</p>
                    <i className="fas fa-angle-down mt-1 ms-1"></i>
                </div>
                <div className="notif-count">
                    <NotifBubble value={ticketNotifCount} />
                </div>
            </a>
            <div
                className="submenu-profile dropdown-menu px-3"
                aria-labelledby="navbarDropdown"
                style={{width:dropdownWidth, boxShadow:"0px 5px 15px rgba(0, 0, 0, 0.1)"}}
            >
                <div className="d-flex justify-content-between px-3 pt-2">
                    <div className="d-flex">
                        <img
                            src={imageUrl}
                            className="hero rounded-circle"
                            alt="Profile"
                            style={{width: "32px",height:"32px"}}
                        />
                        <div className="ms-2">
                            <p className="mb-0" style={{color:"#606094"}}>{user.name.split(" ").splice(0,1).join(" ")}</p>
                            <a href="/my/profile" className="text-decoration-none text-secondary" style={{fontSize:"0.75em"}}>Lihat Profil</a>
                        </div>
                    </div>
                    <div><a href="/my/profile"> <i className="fas fa-angle-right"></i> </a></div>
                </div>
                {/* <div className="dropdown-divider"></div> */}
                <hr className="my-2"/>
                <Link className="dropdown-item text-secondary" href="/event-creator?listby=draft">
                    Event Creator
                </Link>
                <a
                    className="dropdown-item d-flex justify-content-between align-items-center"
                    href="/my/tiket/event"
                >
                    <div className="text-secondary">Tiket</div>
                    {<NotifBubble value={ticketNotifCount} />}
                </a>
                {/* <div className="dropdown-divider"></div> */}
                <hr className="my-2"/>
                <a
                    type="button"
                    className="dropdown-item d-flex justify-content-between align-items-center"
                    onClick={handleLogout}
                >
                    <p className="text-danger mb-0">Keluar</p>
                    {/* <i className="fas fa-sign-out-alt"></i> */}
                </a>
            </div>
        </div>
    );
}

function NavDropdown(props) {
    const menu = useRef(null);
    const menuContent = useRef(null);
    const menuTitle = useRef(null);
    const targetId = Math.floor(Math.random() * 1000);

    useEffect(() => {
        // Window resize listener
        resized();
        window.addEventListener("resize", resized);
        return () => {
            window.removeEventListener("resize", resized);
        };
    }, []);

    function resized() {
        if (window.innerWidth < 992) {
            menuContent.current.classList.remove("dropdown-content");
            menu.current.classList.remove("dropdown");
            menuTitle.current.dataset.bsToggle = "collapse";
        } else {
            menu.current.classList.add("dropdown");
            menuTitle.current.dataset.bsToggle = "";
            menuContent.current.classList.add("dropdown-content");
        }
    }

    return (
        <li className="nav-item" style={{ position: "static" }} ref={menu}>
            <a
                className="nav-link navbar-link
                dropdown-toggle"
                type="button"
                data-bs-target={"#sub-" + targetId}
                aria-controls={"sub-" + targetId}
                aria-expanded="false"
                ref={menuTitle}
            >
                {props.title}
            </a>
            <ul
                id={"sub-" + targetId}
                className="
                collapse
                bg-light
                navbar-nav
                flex-lg-column
                ps-2
                p-lg-2
                "
                style={{ borderRadius: "0 0 10px 10px" }}
                aria-expanded="false"
                ref={menuContent}
            >
                {props.children}
            </ul>
        </li>
    );
}

function DropdownProject(){
    return(
        <NavDropdown title="Manpower">
            <li>
                <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSekzuhJkweFJZWqk_1J6cvYS1DpPMale3qPvjev93pmUYZyyQ/viewform" 
                    target="__blank"
                    className="nav-link navbar-link"
                >Jadi Manpower
                </a>
            </li>
            <li>
                <a
                    href="/cari-manpower" 
                    className="nav-link navbar-link"
                >Cari Manpower
                </a>
            </li>
        </NavDropdown>
    );
}

function DropdownEvent({user, setOpenModal, setRedirectUrl}){
    const createEventLink = user? (
        <Link
            href="/event-creator" 
            className="nav-link navbar-link"
        >Buat Event
        </Link>
    ):(
        <a onClick={(e)=>{
                e.preventDefault();
                setOpenModal(1)
                setRedirectUrl("/event-creator")
            }} 
            className="nav-link navbar-link" style={{cursor:"pointer"}}>
            Buat Event
        </a>
    )
    return(
        <NavDropdown title="Event">
            <li>
                <Link
                    href="/event" 
                    className="nav-link navbar-link"
                >Cari Event
                </Link>
            </li>
            <li>
                {createEventLink}
            </li>
        </NavDropdown>
    );
}


function DropdownAgency() {
    return (
        <NavDropdown title="Agency">
            {/* <li>
                <a href="/about" className="nav-link navbar-link">
                    About
                </a>
            </li> */}
            <li>
                <a href="/partnership" className="nav-link navbar-link">
                    Partnership
                </a>
            </li>
        </NavDropdown>
    );
}

function DropdownMedia() {
    return (
        <NavDropdown title="Media">
            <li>
                <a
                    href="https://blog.metamata.id/"
                    className="nav-link navbar-link"
                    target="__blank"
                >
                    Blog
                </a>
            </li>
            <li>
                <a
                    href="https://www.instagram.com/acaraitu.id/"
                    className="nav-link navbar-link"
                    target="__blank"
                >
                    Instagram
                </a>
            </li>
            {/* <li>
                <a
                    href="https://www.tiktok.com/@metamata.id"
                    className="nav-link navbar-link"
                    target="__blank"
                >
                    Tiktok
                </a>
            </li> */}
            <li>
                <a
                    href="https://www.linkedin.com/company/18964131/admin/feed/posts/"
                    className="nav-link navbar-link"
                    target="__blank"
                >
                    LinkedIn
                </a>
            </li>
            <li>
                <a
                    href="https://open.spotify.com/show/0OjxzzwslXabN87wTeM5Tv?si=7b_Guo7zS-OfPvHFDRfKOg&utm_source=copy-link"
                    className="nav-link navbar-link"
                    target="__blank"
                >
                    Podcast
                </a>
            </li>
        </NavDropdown>
    );
}



export default Navbar;